import React from "react";
import { X, MapPin, Zap, Eye, Briefcase, Download, Apple } from "lucide-react";
import buyProPlanFormMobile from "../../../assets/img/buyProPlanFormMobile.svg";
import four1 from "../../../assets/img/four 1.svg";
import four2 from "../../../assets/img/four 2.svg";
import four7 from "../../../assets/img/four 7.svg";
import apple from "../../../assets/img/apple store dark icon.svg";
import android from "../../../assets/img/play store Light Icon.svg";
import EarlySupporterDiscount from "../../../assets/img/Early Supporter Discount.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

const BuyOfferThankYouPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleViewDetails = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div
      className="custom_container padding_top manage-dashboard-screen"
      style={{ marginBottom: 40 }}
    >
      <div className="pro-welcome">
        <div className="pro-welcome-head">
          <div className="business-form__title_4 mt-0">
            <div className="service_area_search">
              <p>
                <img
                  src={EarlySupporterDiscount}
                  alt="EarlySupporterDiscount"
                  className="mb-1 me-2"
                />
                <span>33.56% OFF Founder Pricing</span>
              </p>
            </div>
          </div>

          <div className="phone-icon">
            <img src={buyProPlanFormMobile} alt="buyProPlanFormMobile" />
          </div>

          <h1 className="title">Welcome to Pro</h1>
          <p className="subtitle">
            Your Pro Plan is now active at <span>$99/month</span>
            <br />
            <span className="price-detail">$149/month - </span> You're saving{" "}
            <span>$50/month!</span>
          </p>
        </div>
        <div className="pro-welcome-secound-sec">
          <div className="next-step">
            <div className="next-step-header">
              <MapPin className="icon" size={20} />
              <h2>Next Step: Maximize Your Pro Benefits</h2>
            </div>
            <p className="next-step-text">
              Use mobile app to access all Pro features, manage bids on-the-go,
              and get instant notifications for high-intent RFQ jobs.
            </p>
          </div>

          <div className="features-section">
            <h3 className="features-title">Your Pro Plan includes:</h3>

            <div className="feature-item">
              <div className="feature-icon ">
                <img src={four1} alt="Credit" />{" "}
              </div>
              <div className="feature-content">
                <h4>100 Credits per month</h4>
                <p>Use for bids, boosts, and much more.</p>
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-icon ">
                <img src={four2} alt="Boosted_Visibility" />
              </div>
              <div className="feature-content">
                <h4>Top-Listed Pro Visibility</h4>
                <p>Appear as a recommended professional in client searches.</p>
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <img src={four7} alt="Bid_credit_protection" />
              </div>
              <div className="feature-content">
                <h4>Ready-To-Go (RTG) Job Access</h4>
                <p>Bid on high-intent clients ready to hire immediately.</p>
              </div>
            </div>

            <p className="more-features">...and many more premium features!</p>
          </div>

          <div className="download-section">
            <Download className="download-icon" size={24} />
            <h3>Access Pro Features On-the-Go</h3>
            <p>Available on iOS - Android coming soon</p>

            <div className="store-buttons">
              <button className="store-btn app-store"   onClick={() => window.open("https://apps.apple.com/us/app/simplerenovate-for-pros/id6754059537", "_blank")}>
                <img src={apple} alt="App Store" />
                <div className="store-text">
                  <span className="store-label">App Store</span>
                </div>
              </button>

              <button className="store-btn play-store disabled">
                <div className="play-icon">
                  <img src={android} alt="Play Store" />
                </div>
                <div className="store-text">
                  <span className="store-label">Play Store</span>
                  <span className="store-status">Coming Soon</span>
                </div>
              </button>
            </div>
          </div>

          <button
            className="cta-button"
            onClick={() => {
              handleViewDetails();
              navigate("/dashboard");
            }}
          >
            Start Using Pro Features Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default BuyOfferThankYouPage;
